<template>
  <div class="o_button" @click="onClickActionButton">
    <span>{{ actionOptionLabel }}</span>
  </div>
</template>

<script>
export default {
  props: {
    actionOptionLabel: {
      type: String,
      default: ''
    }
  },
  methods: {
    /**
     * ボタンがクリックされたときに発火し、親コンポーネントに `on-click-action-button` イベントを送信するメソッド。
     *
     * @emits {Event} on-click-action-button - ボタンがクリックされたことを親コンポーネントに通知するイベント。
     */
    onClickActionButton() {
      this.$emit('on-click-action-button')
    }
  }
}
</script>

<style lang="scss" scoped>
.o_button:hover {
  background-color: #67A3C7;
  color: #ffffff;
  cursor: pointer;
}
span {
  @include responsive-fs(12);
}
</style>



// WEBPACK FOOTER //
// src/components/custom-components/DevSettingActionButton.vue